export const header = {
  nav_home: "Inicio",
  nav_about: "Sobre nosotros",
  nav_services: "Servicios",
  nav_partnership: "Colaboración",
  nav_contact: "Contacto",
  logo_tagline: "linking people & business",
};

export const brand = {
  tagline_linking: "Linking People & Business",
  tagline_excellence: "Driving to excellence with excellent drivers …",
};

export const hero = {
  slide1_title: "Nuevos mercados, nuevos negocios ... ¡sin riesgo!",
  slide2_title: "¡Con nosotros, en el corazón de Europa!",
  slide3_title: "Alemania (DACH): ¡Su éxito con un socio local!",
  slide4_title: "¡Juntos más fuertes!",
  slide4_subtitle: "Desarrollo de negocio\nConsultoría\nInterim Management\nFormación y coaching",
  slide5_title: "¡Iniciar ahora!",
  prev_slide: "Diapositiva anterior",
  next_slide: "Diapositiva siguiente",
  slide_label: "Diapositiva {{number}}",
};

export const intro = {
  title: "NetBasis International - linking people & business",
  paragraph1:
    "Construir, aumentar y/o expandir negocios en nuevos mercados debe ser prometedor, rápido, eficiente, rentable y seguro para las empresas extranjeras. Las investigaciones prolongadas, el desarrollo complicado de estrategias con procesos de decisión poco claros y/o la falta de acceso directo a estos nuevos mercados, por citar solo algunos ejemplos, no son el enfoque correcto ni adecuado. Además, a veces los fabricantes quieren intentar entrar en un nuevo mercado sin grandes inversiones.",
  paragraph2:
    "Todos estos pensamientos y consideraciones conducen a {{strong}} como el socio adecuado para usted, porque desde hace más de doce años acompañamos y apoyamos a empresas extranjeras del sector de las telecomunicaciones y TI en nuevos mercados atractivos pero también exigentes (principalmente la región DACH).",
  strong_name: "NetBasis International",
};

export const services = {
  service1_title: "Desarrollo de negocio",
  service1_description:
    "¿Desea expandir su negocio exitoso en sus mercados de origen a nuevos mercados, o busca apoyo para proyectos ya iniciados en nuevos mercados?",
  service2_title: "Consultoría",
  service2_description:
    "¿Desea asesoramiento en diversas áreas temáticas para entrar en nuevos mercados, a fin de garantizar el éxito de su proyecto empresarial o no ponerlo en peligro?",
  service3_title: "Interim Management",
  service3_description:
    "¿Necesita urgentemente y a corto plazo ayuda competente y temporal para realizar determinadas tareas y/o para cubrir una escasez de personal?",
  service4_title: "Formación y coaching",
  service4_description:
    "¿Desea prepararse de forma óptima para las condiciones de los nuevos mercados, para las constelaciones individuales, así como para los requisitos normativos y las diferencias culturales?",
  read_more: "Más información",
};

export const about = {
  title: "NetBasis International - drive to excellence with excellent drivers !",
  paragraph1:
    "Como expertos reconocidos, con sede en Alemania, el mercado europeo más importante, nosotros de {{strong}} le ayudamos a identificar posibles barreras de entrada, examinar diversas opciones estratégicas, desarrollar conceptos de marketing realistas, encontrar socios estratégicos adecuados y/o acercarse a clientes potenciales. Centrados en su éxito, ofrecemos una amplia gama de servicios, incluyendo planificación de entrada y desarrollo de mercado, ventas, marketing, relaciones públicas, soporte técnico y, si lo desea, también contratación de personal.",
  paragraph2:
    "Cuando trabaja con nosotros, tiene ante todo un punto de contacto central para todo el proyecto y, además, acceso inmediato a todos los conocimientos y la experiencia necesarios e indispensables para su éxito. Con nuestro enfoque pragmático y orientado a resultados, le ayudamos a elaborar las condiciones y requisitos de sus países de destino.",
  paragraph3:
    "Y usted tiene la opción: podemos asumir y cumplir tareas individuales o todas las tareas locales de su empresa, y podemos hacer el trabajo real o el trabajo completo por usted durante un período fijo o indefinido. O le apoyamos de forma puramente consultiva, como consultores puros, en su propio camino. O puede cooperar con nosotros para formación y coaching.",
  paragraph4:
    "Sea cual sea su elección de nuestros servicios, {{strong}} le ayudará a coordinar todos los medios y medidas pertinentes.",
  strong_name: "NetBasis International",
};

export const experience = {
  title: "Experiencia y trayectoria",
  subtitle: "Más de 12 años de exitosa entrada en el mercado y desarrollo de negocio en la región DACH",
  stat1_value: "12+",
  stat1_label: "Años en el negocio",
  stat2_value: "50+",
  stat2_label: "Proyectos completados",
  stat3_value: "30+",
  stat3_label: "Clientes internacionales",
  stat4_value: "4",
  stat4_label: "Áreas de servicio principales",
  intro:
    "Desde nuestra fundación, NetBasis International ha sido el puente de confianza para los fabricantes extranjeros de TIC que entran en los mercados de habla alemana. Nuestra trayectoria habla por sí misma: hemos demostrado repetidamente que con el socio local adecuado, la entrada en el mercado se vuelve predecible, eficiente y exitosa.",
  timeline1_year: "2012",
  timeline1_title: "Fundación y primeros proyectos",
  timeline1_desc: "Fundación de NetBasis International con la visión de conectar empresas innovadoras de TIC de todo el mundo con el mercado DACH. Primeros proyectos exitosos de entrada en el mercado para fabricantes asiáticos y norteamericanos.",
  timeline2_year: "2015",
  timeline2_title: "Ampliación de la cartera de servicios",
  timeline2_desc: "Ampliación de nuestra oferta para incluir servicios integrales de consultoría, gestión interina y programas de formación. Creación de una red de socios de confianza en Alemania, Austria y Suiza.",
  timeline3_year: "2018",
  timeline3_title: "Reconocimiento internacional",
  timeline3_desc: "Reconocimiento como socio líder de go-to-market para la región DACH. Apoyo a clientes de más de 15 países en cuatro continentes para establecer y hacer crecer su presencia europea.",
  timeline4_year: "2022",
  timeline4_title: "Crecimiento estratégico y nuevos mercados",
  timeline4_desc: "Profundización de la experiencia en telecomunicaciones, infraestructura de TI y soluciones digitales. Ampliación de los servicios de consultoría para cubrir el cumplimiento normativo, la adaptación cultural y las estrategias de posicionamiento en el mercado a largo plazo.",
  timeline5_year: "2026",
  timeline5_title: "Su socio para el mañana",
  timeline5_desc: "Evolución continua con el cambiante panorama del mercado. Hoy ofrecemos un conjunto completo de servicios que ayuda a las empresas extranjeras a entrar en la región DACH con confianza, sin riesgo, solo resultados.",
};

export const contact = {
  title: "Póngase en contacto con nosotros directamente ahora.",
  cta_button: "Formulario de contacto",
};

export const footer = {
  privacy: "Protección de datos",
  contact: "Contacto",
  imprint: "Aviso legal",
  copyright: "Copyright © {{year}} NetBasis International. Todos los derechos reservados.",
};

export const pages = {
  about_title: "Sobre nosotros",
  about_subtitle: "Más de 12 años de experiencia en entrada al mercado: conozca al equipo y los logros detrás de NetBasis International",
  about_cta: "¿Listo para su entrada en el mercado?",
  about_cta_button: "Contacte ahora",
  about_footer_claim: "NetBasis International - drive to excellence with excellent drivers !",
  experience_title: "Experiencia",
  contact_title: "Contacto",
  privacy_title: "Protección de datos",
  imprint_title: "Aviso legal",
  placeholder: "Esta página se llenará de contenido en breve. ¡Estamos trabajando en ello!",
};

export const aboutHero = {
  title_line1: "¡Hacemos que las ",
  title_line2: "cosas se muevan ...",
  subtitle: "... para USTED!",
  heroAlt: "Un dedo toca un punto digital luminoso para la interconexión TIC en el mercado DACH.",
};

export const aboutPage = {
  introTitle: "NetBasis International - linking people & business",
  p1: "NetBasis International fue fundada a principios de 2008 en Düsseldorf. Desde entonces, ofrecemos a los fabricantes extranjeros del sector de las telecomunicaciones y/o TI que desean expandir su negocio en los mercados DACH o intensificar sus actividades existentes, bajo el lema \"linking people & business\", cualquier forma de consultoría y apoyo comercial, así como ayuda en el desarrollo o adaptación de productos específicos para el mercado.",
  p2: "¡Junto con nuestros socios fabricantes, respondemos a todas las preguntas y trabajamos para ellos con un único objetivo: éxito y los mejores resultados de negocio en nuevos mercados!",
  p3: "Para alcanzar este objetivo, las empresas extranjeras obtienen a través de nosotros acceso inmediato a conocimientos específicos del sector, años de experiencia y amplios contactos; con nosotros evitan barreras culturales y/o lingüísticas con presencia inmediata; y reciben de nosotros un trabajo rápido en el/los mercado(s), producto(s), socios y clientes.",
  p4: "Para fortalecer las relaciones existentes y atraer nuevos clientes, y así para el desarrollo sostenible de nuevos mercados, fomentamos un enfoque justo y cooperativo en todas las áreas de ventas y marketing, así como un trabajo colaborativo en productos y soluciones exigentes (hardware y software), bien adaptados a las necesidades del mercado.",
  p5: "Tanto nuestra filosofía corporativa como nuestra orientación ética implican que NetBasis International se concentre estratégicamente en un número limitado de socios fabricantes competentes que no compiten dentro del sector. Porque damos preferencia al desarrollo conjunto y la colaboración sinérgica dentro del grupo sobre la competencia improductiva.",
  p6: "Todo esto proporciona seguridad a cada nuevo socio y es parte del paquete que le ofrecemos si decide trabajar con nosotros.",
  footerClaim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const aboutCards = {
  management_title: "Dirección",
  management_desc:
    "Christof Günther fundó NetBasis International a principios de 2008 y es el propietario. Con más de 30 años de experiencia internacional en el sector de las TIC, ayuda a los fabricantes extranjeros a desarrollar nuevos mercados con sus productos.",
  core_values_title: "Valores fundamentales",
  core_values_desc:
    "Respeto. Lealtad. Profesionalidad. Perseverancia. Confianza. Estos son los valores fundamentales a los que NetBasis International se ha comprometido y que nos guían en nuestro trabajo diario.",
  mission_vision_title: "Misión/Visión",
  mission_vision_desc:
    "Sí, siempre son los resultados lo que cuenta al final. ¡Pero lo decisivo en el camino son siempre las personas! NetBasis International le permite comenzar fácilmente su negocio en nuevos mercados.",
  read_more: "Más información",
};

export const aboutSubPages = {
  management: {
    title: "Dirección",
    heroLine1: "¡Impulsados por la experiencia!",
    heroLine2: "",
    heroAlt: "Una mano elige un perfil destacado para una gestión TIC competente en el mercado DACH.",
    p1_founded: "fundó ",
    p1_owner: "a principios de 2008 y es el propietario.",
    p1: "Christof Günther fundó NetBasis International a principios de 2008 y es el propietario.",
    p2: "Con más de 30 años de experiencia internacional en el sector de las TIC, el Sr. Günther ayuda a los fabricantes extranjeros a desarrollar nuevos mercados con sus productos. Su enfoque profesional se centra en todas las áreas del \"Business Development\", elaborando conceptos integrales de entrada al mercado para y con sus socios comerciales y apoyándoles en la implementación y control de todos sus planes de proyecto.",
    p3: "También ofrece a las empresas interesadas su conocimiento del mercado y su experiencia en el sector a través de mandatos de asesoramiento y/o mediante formación y coaching.",
    p4: "Anteriormente, el Sr. Günther ocupó puestos de responsabilidad (director de sucursal, director de ventas, director de exportación, etc.) en empresas medianas de telecomunicaciones y TI activas en Europa y/o en todo el mundo.",
  },
  core_values: {
    title: "Valores fundamentales",
    heroLine1: "Con valores",
    heroLine2: "¡al éxito!",
    heroAlt: "Una mano abierta sostiene líneas digitales que simbolizan confianza y valores en NetBasis.",
    p1: "Respeto. Lealtad. Profesionalidad. Perseverancia. Confianza.",
    p2: "Estos son los valores fundamentales a los que NetBasis International se ha comprometido y que nos guían en nuestro trabajo diario. Nos acompañan en nuestra responsabilidad hacia nuestros socios comerciales y nos guían en la forma en que realizamos nuestro trabajo.",
    p3: "Es nuestra exigencia hacia nosotros mismos demostrar tanto a los nuevos socios que con nosotros han tomado la decisión correcta, como mostrar a los socios existentes en nuevos proyectos, una y otra vez, que con nosotros están en buenas manos.",
    p4: "Su éxito es nuestro compromiso.",
  },
  mission_vision: {
    title: "Misión/Visión",
    heroLine1: "Con trabajo en equipo",
    heroLine2: "¡al éxito!",
    heroAlt: "Miembros de equipo apilan sus manos para una entrada conjunta en el mercado DACH.",
    p1: "Sí, siempre son los resultados lo que cuenta al final. ¡Pero lo decisivo en el camino son siempre las personas!",
    p2: "NetBasis International le permite comenzar fácilmente su negocio en nuevos mercados y lograr rápidamente (no solo los primeros) resultados. Con un buen producto/solución, le capacitamos para implementar su estrategia sin demora y hacerla exitosa. Le damos el potencial para ser ágil y competitivo.",
    p3: "Sin embargo, el negocio exitoso no puede y no se logrará solo con productos/soluciones. Los productos/soluciones no se venden por sí mismos. Los productos/soluciones excelentes por sí solos no traerán resultados ni éxito.",
    p4: "Los resultados y el éxito, especialmente a largo plazo, comienzan con las PERSONAS y necesitan PERSONAS. Siempre son las PERSONAS las que construyen relaciones, trabajan juntas en estrategias y objetivos de negocio individuales y desarrollan el curso de acción más adecuado para cumplir con los requisitos, planes y objetivos. Creemos en este enfoque centrado en las personas y estamos convencidos de que esto es lo que marca la diferencia en los negocios.",
    p5: "Por eso, la colaboración buena e intensiva es nuestro camino central para hacer negocios. Nuestros expertos unen fuerzas con su gente para formar un equipo fuerte y cercano, un equipo de \"drivers\" que sin duda hará que su proyecto de entrada al mercado sea un éxito.",
  },
};

export const experiencePage = {
  title: "Experiencia",
  heroClaimLine1: "Experiencia y pericia",
  heroClaimLine2: "... ¡la base para su éxito!",
  benefits_title: "Lo que puede esperar aquí pronto",
  benefit_0: "Resumen de proyectos y entradas al mercado completados con éxito",
  benefit_1: "Testimonios de clientes y experiencias de colaboración",
  benefit_2: "Información detallada sobre el conocimiento del sector y del mercado",
  benefit_3: "Cronología e hitos de nuestra historia empresarial",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const contactPage = {
  hero: {
    title: "¡Esperamos",
    subtitle: "su mensaje!",
    heroAlt: "Dos manos presentan una tarjeta de visita en blanco para contactar con NetBasis en Düsseldorf.",
  },
  details: {
    title: "Datos de contacto",
    company: "NetBasis International",
    address_line1: "Heinrichstraße 45",
    address_line2: "40239 Düsseldorf",
    address_country: "Alemania",
    tel_label: "Teléfono:",
    tel_number: "+49 (0) 211 / 544 193 80",
    email_label: "Correo electrónico:",
    email_address: "contact@net-basis.com",
  },
  form: {
    title: "No dude en contactarnos",
    name: "Nombre y apellido",
    name_placeholder: "Su nombre",
    company: "Empresa",
    company_placeholder: "Su empresa",
    email: "Dirección de correo electrónico",
    email_placeholder: "su@email.es",
    phone: "Número de teléfono",
    phone_placeholder: "+49 (0) ...",
    message: "Su mensaje",
    message_placeholder: "Su mensaje para nosotros...",
    dsgvo_text: "Acepto que mis datos del formulario de contacto sean recopilados y procesados para responder a mi consulta. Los datos se eliminarán una vez finalizado el procesamiento de su consulta. Puede revocar su consentimiento para el futuro en cualquier momento enviando un correo electrónico a contact@net-basis.com. Encontrará información detallada sobre el tratamiento de los datos de los usuarios en nuestra política de privacidad.",
    submit: "enviar",
    success_title: "¡Gracias!",
    success_message: "Su mensaje se ha enviado con éxito. Nos pondremos en contacto con usted lo antes posible.",
    error_default: "Se ha producido un error. Por favor, inténtelo de nuevo más tarde.",
    spam_question: "Pregunta de seguridad: ¿Cuánto es",
    spam_error: "Por favor, responda a la pregunta de seguridad.",
    spam_wrong: "Esa respuesta es incorrecta. Por favor, inténtelo de nuevo.",
  },
  map: {
    title: "Nuestra ubicación",
    preview_title: "Google Maps está desactivado",
    preview_text: "Al activar Google Maps, su dirección IP se transmitirá a los servidores de Google en EE. UU. Encontrará más detalles en nuestra política de privacidad.",
    activate_button: "Activar contenido",
  },
};

export const cookie_banner = {
  text: "Este sitio web utiliza únicamente cookies técnicamente necesarias. No se utilizan cookies de seguimiento ni de análisis. Una cookie almacena su preferencia de uso de Google Maps, otra sirve para la protección contra bots de Cloudflare.",
  privacy_link: "Más información en nuestra política de privacidad.",
  button: "Entendido",
};

export const legalPage = {
  heroAlt: "Un dedo toca signos § conectados para el aviso legal y la protección de datos de NetBasis.",
};

export const imprintPage = {
  title: "Aviso legal",
  left_title: "Aviso legal",
  provider_title: "Información según § 5 DDG",
  provider_text: "Christof Günther\nNetBasis International\nHeinrichstraße 45\n40239 Düsseldorf\nAlemania",
  contact_title: "Contacto",
  phone_label: "Teléfono:",
  phone: "+49 (0) 211 / 544 193 80",
  email_label: "Correo electrónico:",
  email: "contact@net-basis.com",
  web_label: "Internet:",
  web: "net-basis.net",
  vat_title: "Número de identificación fiscal",
  vat_text: "Número de identificación a efectos del IVA según § 27 a UStG:\nDE 258 486 954",
  insurance_title: "Seguro de responsabilidad civil profesional",
  insurance_text: "Nombre y domicilio social de la aseguradora:\nHiscox AG en representación de Hiscox Insurance Company Ltd.\nSucursal para Alemania, Arnulfstraße 31, 80636 Múnich\nÁmbito de cobertura: Mundial",
  right_title: "Descargo de responsabilidad",
  disclaimer_content_title: "Responsabilidad por el contenido",
  disclaimer_content_text: "El contenido de nuestro sitio web ha sido creado con el máximo cuidado. Sin embargo, no podemos garantizar la exactitud, integridad y actualidad del contenido. Como proveedor de servicios, somos responsables de nuestro propio contenido en estas páginas de acuerdo con las leyes generales. Sin embargo, no estamos obligados a supervisar la información de terceros transmitida o almacenada ni a investigar circunstancias que indiquen una actividad ilegal. Las obligaciones de eliminar o bloquear el uso de la información según las leyes generales no se ven afectadas. Sin embargo, la responsabilidad a este respecto solo es posible a partir del momento en que tengamos conocimiento de una infracción concreta. En cuanto tengamos conocimiento de las correspondientes infracciones legales, eliminaremos este contenido de inmediato.",
  disclaimer_links_title: "Responsabilidad por los enlaces",
  disclaimer_links_text: "Nuestra oferta contiene enlaces a sitios web externos de terceros, sobre cuyo contenido no tenemos ninguna influencia. Por lo tanto, no podemos asumir ninguna responsabilidad por estos contenidos externos. El respectivo proveedor u operador de las páginas enlazadas es siempre responsable del contenido de las mismas. Las páginas enlazadas fueron revisadas en el momento de la vinculación para detectar posibles violaciones legales. En el momento de la vinculación no se reconocían contenidos ilegales. Sin embargo, un control permanente del contenido de las páginas enlazadas no es razonable sin indicios concretos de una violación legal. En cuanto tengamos conocimiento de infracciones legales, eliminaremos dichos enlaces de inmediato.",
  disclaimer_copyright_title: "Derechos de autor",
  disclaimer_copyright_text: "El contenido y las obras creadas o utilizadas por nosotros en estas páginas están sujetos a la ley alemana de derechos de autor. La reproducción, el procesamiento, la distribución y cualquier tipo de explotación fuera de los límites de los derechos de autor requieren nuestro consentimiento. Las descargas y copias de este sitio solo están permitidas para uso privado y no comercial. En la medida en que el contenido de nuestro sitio no haya sido creado por nosotros, se respetan los derechos de autor de terceros. En particular, el contenido de terceros se identifica como tal. No obstante, si tuviera conocimiento de una infracción de los derechos de autor, le rogamos que nos lo comunique. En cuanto tengamos conocimiento de infracciones legales, eliminaremos dicho contenido de inmediato.",
  image_credits_title: "Créditos de imágenes",
  image_credits_intro: "Las imágenes de Fotolia/Adobe Stock utilizadas en este sitio web han sido debidamente licenciadas. Consulte el siguiente resumen para obtener información detallada sobre los derechos de autor:",
  image_credits_placeholder: "Marcador de posición para créditos de imágenes (lista de Fotolia/Adobe Stock)",
};

export const buttonizer = {
  trigger_label: "Contacto",
  phone_label: "Llamar",
  email_label: "Correo electrónico",
  email_address: "contact@net-basis.com",
  whatsapp_label: "WhatsApp",
  whatsapp_link: "https://wa.me/4915126386361",
  telegram_label: "Telegram",
  telegram_link: "https://t.me/ChriGue1",
  signal_label: "Signal",
  signal_link: "https://signal.me/#p/+4915126386361",
  messenger_label: "Messenger",
  messenger_link: "https://m.me/ChriGue1",
  phone_number: "+4921154419380",
  phone_display: "+49 (0) 211 / 544 193 80",
};

export const notFound = {
  title: "Esta página aún no ha sido generada",
  message: "Cuéntenos más sobre esta página para que podamos generarla para usted.",
};